import { render, staticRenderFns } from "./Feedbackmanage.vue?vue&type=template&id=66c80930&scoped=true&"
import script from "./Feedbackmanage.vue?vue&type=script&lang=js&"
export * from "./Feedbackmanage.vue?vue&type=script&lang=js&"
import style0 from "./Feedbackmanage.vue?vue&type=style&index=0&id=66c80930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c80930",
  null
  
)

export default component.exports